import { create } from 'zustand';

interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  organization_id: string | null;
  is_active: boolean;
  created_at: string;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => {
  // Load user from localStorage on init
  const storedTokens = localStorage.getItem('guideai_jwt_tokens');
  const storedUser = localStorage.getItem('guideai_jwt_user');

  let initialUser: User | null = null;
  if (storedTokens && storedUser) {
    try {
      initialUser = JSON.parse(storedUser);
      // Only allow super_admin users
      if (initialUser?.role !== 'super_admin') {
        initialUser = null;
        localStorage.removeItem('guideai_jwt_tokens');
        localStorage.removeItem('guideai_jwt_user');
      }
    } catch {
      initialUser = null;
    }
  }

  return {
    user: initialUser,
    isAuthenticated: !!initialUser,
    setUser: (user) => {
      // Only allow super_admin users
      if (user && user.role !== 'super_admin') {
        set({ user: null, isAuthenticated: false });
        return;
      }
      set({ user, isAuthenticated: !!user });
    },
    logout: () => {
      localStorage.removeItem('guideai_jwt_tokens');
      localStorage.removeItem('guideai_jwt_user');
      localStorage.removeItem('guideai_admin_key');
      localStorage.removeItem('guideai_key_type');
      localStorage.removeItem('guideai_current_site');
      set({ user: null, isAuthenticated: false });
    },
  };
});
